<!-- AppTable.vue -->
<template>
  <div class="as-wrap">
    <table class="as-table">
      <thead>
        <tr>
          <th
            v-for="col in colunas"
            :key="col.label"
            :style="col.width ? `width:${col.width}` : ''"
            :class="{
              'as-th-right':  col.align === 'right',
              'as-th-center': col.align === 'center',
            }"
          >{{ col.label }}</th>
        </tr>
      </thead>
      <tbody>
        <slot />
      </tbody>
    </table>

    <div v-if="empty" class="as-empty">
      <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#c0c0c0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
      </svg>
      <p>{{ emptyMessage }}</p>
    </div>
  </div>
</template>

<script setup>
/**
 * AppTable — container visual da tabela.
 *
 * Props:
 *   colunas       Array<{ label, align?, width? }>   cabeçalhos
 *   empty         Boolean                            exibe estado vazio
 *   emptyMessage  String                             mensagem do estado vazio
 *
 * Uso:
 *   <AppTable :colunas="[{ label: 'Nome' }, { label: 'Preço', align: 'right' }]">
 *     <AppTrow v-for="item in lista" :key="item.id" :data="[item.name, item.price]" />
 *   </AppTable>
 */
defineProps({
  colunas: {
    type: Array,
    default: () => [],
    // [{ label: 'Nome', align?: 'left'|'right'|'center', width?: '120px' }]
  },
  empty:        { type: Boolean, default: false },
  emptyMessage: { type: String,  default: 'Nenhum registro encontrado.' },
})
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;600&family=JetBrains+Mono:wght@500&display=swap');

.as-wrap {
  background: #fff;
  border: 0.5px solid rgba(0,0,0,0.08);
  border-radius: 14px;
  overflow: hidden;
  font-family: 'Sora', sans-serif;
}

.as-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.as-table thead th {
  background: #f9f9f7;
  border-bottom: 0.5px solid rgba(0,0,0,0.08);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #9a9a9a;
  padding: 12px 16px;
  white-space: nowrap;
  text-align: left;
}
.as-th-right  { text-align: right  !important; }
.as-th-center { text-align: center !important; }

.as-empty {
  padding: 56px 20px;
  text-align: center;
  color: #b0b0b0;
  font-size: 13px;
}
.as-empty svg { display: block; margin: 0 auto 12px; }
.as-empty p   { margin: 0; }
</style>